import OuterWrap from './OuterWrap';
import MainWrapper from './MainWrapper';
import Generic from './Generic';
import Page from './Page';
import Blank from './Blank';
import MapPage from './MapPage';

export { OuterWrap, MainWrapper, Generic, Page, Blank, MapPage };
